import { render, staticRenderFns } from "./dailyAttendanceWanting.vue?vue&type=template&id=789ae220&"
import script from "./dailyAttendanceWanting.vue?vue&type=script&lang=js&"
export * from "./dailyAttendanceWanting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports